import { useEffect } from 'react';

/** Sync --kuutio-vh / --kuutio-vw to the visible viewport (innerHeight, visualViewport). */
export function setViewportCssVars() {
  const h = window.visualViewport?.height ?? window.innerHeight;
  const w = window.visualViewport?.width ?? window.innerWidth;
  document.documentElement.style.setProperty('--kuutio-vh', `${Math.round(h)}px`);
  document.documentElement.style.setProperty('--kuutio-vw', `${Math.round(w)}px`);
}

/** Mount once near the app root so full-screen layouts track the real visible area. */
export function useViewportSync() {
  useEffect(() => {
    setViewportCssVars();
    const update = () => setViewportCssVars();
    window.addEventListener('resize', update);
    const vv = window.visualViewport;
    vv?.addEventListener('resize', update);
    vv?.addEventListener('scroll', update);
    return () => {
      window.removeEventListener('resize', update);
      vv?.removeEventListener('resize', update);
      vv?.removeEventListener('scroll', update);
    };
  }, []);
}
